import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useTransferOperationList = () => {
  const [loading, setLoading] = useState(false);
  const [transferOperationList, setTransferOperationList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getTransferOperationList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('Operation/Transfer/List', {
        params: {
          Guid: params.Guid,
          Count: params.Count,
          Term: params.Term,
          Page: params.Page,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setTransferOperationList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              guid: element.guid,
              title: element.title,
              agentName: element.agentName,
              state: element.state,
              type: element.type,
              shortCode: element.shortCode,
              dateTime: element.dateTime,
              voucherTypeDisplay: element.voucherTypeDisplay,
              hasVoucher: element.hasVoucher,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return {
    getTransferOperationList,
    loading,
    transferOperationList,
    pageRef,
  };
};

export default useTransferOperationList;
